import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useParams, useHistory, Link } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import { SubscriptionFormParams, SUBSCRIPTION_OFFERS, formatter } from "./SubscriptionForm";


export const SubscriptionOfferSelect = () => {
  const { defaultOfferId } = useParams<SubscriptionFormParams>();
  const { setValue, watch, formState: { errors } } = useFormContext();
  useEffect(() => {
    setValue("offerId", defaultOfferId);
  }, []);
  const { data, error, loading } = useQuery(SUBSCRIPTION_OFFERS, { variables: { uuid: watch("offerId") } });
  if (error)
    return <div>Error loading subscription offers. Please try again later or contact our office for assistance.</div>;
  if (loading)
    return (<div className="h-64"></div>);
  const { getSubscriptionOffers } = data;
  if (data && data.getSubscriptionOffers.length === 0)
    return <div>No current subscription offers.</div>;
  if (data.getSubscriptionOffers.length === 1 && !watch("offerId"))
    setValue("offerId", data.getSubscriptionOffers[0].uuid);
  const selectedOffer = data && data.getSubscriptionOffers ? getSubscriptionOffers.reduce((prev, curr) => (watch("offerId") === curr.uuid ? curr : prev), null) : false;
  return selectedOffer ? (
    <React.Fragment>
      <div className="bg-white shadow-lg border sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Selected Offer</h3>
          <div className="mt-2 sm:flex sm:items-start sm:justify-between">
            <div className="max-w-xl text-sm text-gray-500">
              <p>{selectedOffer.offerName}: {selectedOffer.displayPrice}</p>
            </div>
            <div className="mt-2 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
              {data.getSubscriptionOffers.length > 1 ? (
              <button onClick={() => setValue("offerId", "")} type="button" className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                Change selected offer
                </button>
              ) : null }
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <div className=" grid gap-4 grid-cols-1 md:grid-cols-3">
        {getSubscriptionOffers.map(({ offerName, features, displayPrice, discountFinePrint, uuid, promoImageUrl }, idx) => {
          return idx < 3 ? (
              <div key={idx} className={`${idx===0 ? "order-3":""} ${idx===1 ? "order-1 z-10 md:-mt-6 md:-mb-2":"flex-shrink"} w-full flex flex-col text-center bg-indigo-50 rounded-lg shadow divide-y divide-gray-200`} >
                <div className="flex-1 flex flex-col p-8">
                  <h3 className="mt-2 text-gray-900 text-sm font-medium">{offerName}</h3>
                  {!promoImageUrl ? <img className="w-full max-h-64 flex-shrink-0 mx-auto" src={promoImageUrl} alt="" /> : null }
                  <dl className="mt-1 flex-grow flex flex-col justify-between">
                    <dt className="sr-only">Offer Name</dt>
                    <dd className="text-gray-500 text-sm">{features}</dd>
                    <dt className="sr-only">Details</dt>
                    <dd className="mt-3">
                      {discountFinePrint ? discountFinePrint.split("\\n/").map(line => (<span className="px-2 py-1 text-green-800 text-xs font-medium bg-green-100 rounded-full">{line}</span>)) : null}
                    </dd>
                    <dt className="sr-only">Price</dt>
                    <dd className="text-gray-500 text-sm">{displayPrice}</dd>
                  </dl>
                </div>
                <div>
                  <div className="-mt-px flex divide-x divide-gray-200">
                    <div className="w-0 flex-1 flex bg-indigo-300">
                      <div onClick={() => setValue("offerId", uuid )} className="cursor-pointer relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                        <span className="ml-3">Choose this offer</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          ) : (
            null
          );
        })}
      </div>
      <div>{errors.offerId ? "You must choose one of the above offers in order to subscribe" : ""}</div>
    </React.Fragment>
  );
};
